export default __webpack_public_path__ + "static/media/iPadSS5.2f54f952.png";